import { HTMLAttributes } from 'react';

import { FormError } from './FormError';
import { FormItem } from './FormItem';
import { FormItemControlled } from './FormItemControlled';
import { FormUIContext } from './FormUIProvider';

import type { FormUIContextValue } from './FormUIProvider';

export type FormProps = HTMLAttributes<HTMLFormElement> & FormUIContextValue;

export const Form = (props: FormProps) => {
  const { labelWidth, labelStyle, style, ...args } = props;

  return (
    <FormUIContext.Provider value={{ labelWidth, labelStyle }}>
      <form {...args} />
    </FormUIContext.Provider>
  );
};

Form.Error = FormError;
Form.Item = FormItem;
Form.ItemControlled = FormItemControlled;
